import {MutableRefObject, useEffect, useState} from "react";
import {DEFAULT_ANIMATION_TIME} from "../global-constants";


export default function useIsInViewPort(ref: MutableRefObject<any>) {

    const [isIntersecting, setIntersecting] = useState(false);


    const observer = new IntersectionObserver(
        ([entry]) => setIntersecting(entry.isIntersecting)
    );

    useEffect(() => {
        let timeout: any = null;
        if(ref.current) {
            //set timeout here is to give any animation the chance to finish otherwise the element might not be yet in the viewport
            timeout =  setTimeout(() => {
                observer.observe(ref.current);
            }, DEFAULT_ANIMATION_TIME + 50);

        }
        return () => {
            try {
                if(timeout) {
                    clearTimeout(timeout);
                }
                observer?.disconnect()
            } catch (err) {
                console.error('Failed to disconnect observer');
            }
        }
    });

    return isIntersecting;
}
